import {
  Circle,
  Info,
  Loader,
  LucideUpload,
  Plus,
  Search,
  Sigma,
  SortAsc,
  UserPlus,
} from "lucide-react";
import { useQuery, useMutation } from "react-query";
import {
  addNextOfKin,
  borrowersTotals,
  createBorrower,
  getAllBorrowers,
  updateBorrower,
} from "../../sdk/borrower/borrower";
import { useState } from "react";
import { useFormattedDate } from "../../hooks/useFormattedDate";
import Pagination from "../../shared/Pagination";
import BorrowerCard from "../../shared/BorrowerCard";
import BorrowerFilter from "../../components/filter/BorrowerFilter";
import BorrowersSkeleton from "../../skeletons/BorrowerSkeleton";
import { useNavigate } from "react-router-dom";
import PersonalInformation from "../../components/add-borrower/PersonalInformation";
import BioInformation from "../../components/add-borrower/BioInformation";
import NextOfKin from "../../components/add-borrower/NextOfKin";
import BorrowerSuccess from "../../components/add-borrower/BorrowerSuccess";
import { useError } from "../../context/ErrorProvider";
import { useBorrower } from "../../context/BorrowerContext";
import Loading from "../../shared/Loading";
import {
  exportAllBorrowers,
  exportAllSelectedBorrowers,
} from "../../sdk/exports/export";
import { downloadExportFile } from "../../utils/export";
import { Dropdown, Button } from "antd";

const Borrrowers = () => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(20);
  const [fromDate, setFromDate] = useState(new Date("2023-11-23"));
  const [toDate, setToDate] = useState(new Date());
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");
  const [selectedGender, setSelectedGender] = useState([]);
  const [borrowers, setBorrowers] = useState([]);
  const formatDate = useFormattedDate();
  const [selectedBorrowers, setSelectedBorrowers] = useState("");
  const [openBorrowerFilter, setOpenBorrowerFilter] = useState(false);
  const navigate = useNavigate();
  const { showError } = useError();
  const { borrower, setBorrower } = useBorrower();
  const allSelected =
    borrowers?.length > 0 && selectedBorrowers.length === borrowers.length;
  const [borrowerInfo, setBorrowerInfo] = useState({
    username: "",
    maritalStatus: "",
    phoneNumber: "",
    altPhoneNumber: "",
    email: "",
    dependants: "",
    postalAddress: "",
  });

  const items = [
    {
      key: "csv",
      label: "Export as CSV",
      onClick: () => exportBorrowers({ format: "csv" }),
    },
    {
      key: "pdf",
      label: "Export as PDF",
      onClick: () => exportBorrowers({ format: "pdf" }),
    },
  ];

  const selectedItems = [
    {
      key: "csv",
      label: "Export as CSV",
      onClick: () => exportSelectedBorrowers({ format: "csv" }),
    },
    {
      key: "pdf",
      label: "Export as PDF",
      onClick: () => exportSelectedBorrowers({ format: "pdf" }),
    },
  ];

  const [idDetails, setIdDetails] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    identification: "",
    identification_type: "National ID",
    dateOfBirth: "",
    country_of_residence: "Kenya",
    citizenship: "Kenyan",
    gender: "",
    id_back_image: "",
    id_front_image: "",
  });

  const [kinDetails, setKinDetails] = useState({
    name: "",
    dateOfBirth: "",
    relationship: "",
    phoneNumber: "",
    location: "",
  });
  const [selectedFrontIdFile, setSelectedFrontIdFile] = useState(null);
  const [selectedBackIdFile, setSelectedBackIdFile] = useState(null);
  const [openPersonalInformation, setOpenPersonalInformation] = useState(false);
  const [openBioInformation, setOpenBioInformation] = useState(false);
  const [openNextOfKin, setOpenNextOfKin] = useState(false);
  const [openAddBorrowerSuccess, setOpenAddBorrowerSuccess] = useState(false);

  const togglePersonalInformation = () => {
    setOpenPersonalInformation(true);
  };
  const closePersonalInformation = () => {
    setOpenPersonalInformation(false);
  };

  const handleCollectPersonalDetails = () => {
    borrowerMutate();
  };

  const toggleBioInformation = () => {
    setOpenBioInformation(true);
  };
  const closeBioInformation = () => {
    setOpenBioInformation(false);
  };

  const handleCollectBioDetails = () => {
    updateMutate();
  };

  const toggleNextOfKin = () => {
    setOpenNextOfKin(true);
  };
  const closeNextOfKin = () => {
    setOpenNextOfKin(false);
  };

  const toggleAddBorrowerSuccess = () => {
    setOpenAddBorrowerSuccess(true);
  };
  const closeAddBorrowerSuccess = () => {
    setOpenAddBorrowerSuccess(false);
  };

  const displayBorrowerFilter = () => {
    setOpenBorrowerFilter(true);
  };

  const closeBorrowerFilter = () => {
    setOpenBorrowerFilter(false);
  };

  const handleCompleteBorrowerRegistration = () => {
    kinMutate();
  };

  const handlePageChange = (page) => {
    setPage(page);
  };

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedBorrowers([]);
    } else {
      setSelectedBorrowers(borrowers.map((b) => b.id));
    }
  };

  const toggleSelectBorrower = (id) => {
    if (selectedBorrowers.includes(id)) {
      setSelectedBorrowers(selectedBorrowers.filter((bid) => bid !== id));
    } else {
      setSelectedBorrowers([...selectedBorrowers, id]);
    }
  };

  const { mutate: borrowerMutate, isLoading: isLoadingBorrower } = useMutation({
    mutationKey: ["create borrower"],
    mutationFn: () =>
      createBorrower(
        borrowerInfo.altPhoneNumber,
        borrowerInfo.email,
        borrowerInfo.phoneNumber,
        borrowerInfo.maritalStatus,
        borrowerInfo.dependants,
        borrowerInfo.username,
        borrowerInfo.postalAddress,
      ),
    onSuccess: (data) => {
      setBorrower(data);
      closePersonalInformation();
      toggleBioInformation();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const { mutate: updateMutate, isLoading: isLoadingBioInformation } =
    useMutation({
      mutationKey: ["update borrower"],
      mutationFn: () =>
        updateBorrower(
          borrower?.id,
          idDetails.firstName,
          idDetails.middleName,
          idDetails.lastName,
          idDetails.identification,
          idDetails.identification_type,
          idDetails.country_of_residence,
          idDetails.dateOfBirth,
          idDetails.citizenship,
          idDetails.gender,
          idDetails.id_back_image,
          idDetails.id_front_image,
        ),
      onSuccess: () => {
        closeBioInformation();
        toggleNextOfKin();
      },
      onError: (errors) => {
        showError(errors?.response?.data?.message || errors.message);
      },
    });

  const { mutate: kinMutate, isLoading: isLoadingKin } = useMutation({
    mutationKey: ["nextOfKin"],
    mutationFn: () =>
      addNextOfKin(
        borrower?.id,
        kinDetails.name,
        kinDetails.dateOfBirth,
        kinDetails.relationship,
        kinDetails.phoneNumber,
        kinDetails.location,
      ),
    onSuccess: () => {
      refetchBorrowers();
      closeNextOfKin();
      toggleAddBorrowerSuccess();
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const { mutate: exportBorrowers, isLoading: loadingCustomers } = useMutation({
    mutationKey: ["export customers"],
    mutationFn: ({ format }) =>
      exportAllBorrowers(format, fromDate, toDate, status),
    onSuccess: (blob, variables) => {
      downloadExportFile(blob, `borrowers.${variables.format}`);
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const {
    mutate: exportSelectedBorrowers,
    isLoading: loadingSelectedCustomers,
  } = useMutation({
    mutationKey: ["export customers"],
    mutationFn: ({ format }) =>
      exportAllSelectedBorrowers(selectedBorrowers, format),
    onSuccess: (blob, variables) => {
      downloadExportFile(blob, `borrowers.${variables.format}`);
    },
    onError: (errors) => {
      showError(errors?.response?.data?.message || errors.message);
    },
  });

  const {
    refetch: refetchBorrowers,
    isRefetching,
    isLoading,
  } = useQuery({
    queryKey: [
      "borrowers",
      page,
      limit,
      fromDate ? fromDate.toISOString() : null,
      toDate ? toDate.toISOString() : null,
      status,
    ],
    queryFn: async () => {
      const response = await getAllBorrowers(
        page,
        limit,
        fromDate ? fromDate.toISOString() : null,
        toDate ? toDate.toISOString() : null,
        search,
        status,
      );
      return response.data.data;
    },
    onSuccess: (data) => {
      setBorrowers(data.items);
      setPage(data.meta.currentPage);
      setLimit(data.meta.itemsPerPage);
      setTotalPages(data.meta.totalPages);
      setTotalItems(data?.meta?.totalItems);
    },
  });

  const { data: borrowersStatistics } = useQuery({
    queryKey: ["borrowers with loans"],
    queryFn: () => borrowersTotals(),
    initialData: {},
  });

  const handleApplyFilters = () => {
    closeBorrowerFilter();
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, totalItems);

  return (
    <>
      {openPersonalInformation && (
        <PersonalInformation
          closePersonalInformation={closePersonalInformation}
          activeIndex={0}
          handleNextStep={handleCollectPersonalDetails}
          borrowerInfo={borrowerInfo}
          setBorrowerInfo={setBorrowerInfo}
          errors={{}}
          loading={isLoadingBorrower}
          isDisabled={true}
          handleBack={() => {}}
        />
      )}

      {openBioInformation && (
        <BioInformation
          closeBioInformation={closeBioInformation}
          activeIndex={1}
          handleNextStep={handleCollectBioDetails}
          selectedFrontIdFile={selectedFrontIdFile}
          selectedBackIdFile={selectedBackIdFile}
          setSelectedFrontIdFile={setSelectedFrontIdFile}
          setSelectedBackIdFile={setSelectedBackIdFile}
          idDetails={idDetails}
          setIdDetails={setIdDetails}
          loading={isLoadingBioInformation}
          handleBack={() => {
            closePersonalInformation();
            setOpenBioInformation(true);
          }}
          isDisabled={false}
        />
      )}

      {openNextOfKin && (
        <NextOfKin
          closeKinInformation={closeNextOfKin}
          activeIndex={2}
          handleNextStep={handleCompleteBorrowerRegistration}
          kinDetails={kinDetails}
          setKinDetails={setKinDetails}
          loading={isLoadingKin}
          handleBack={() => {
            closeBioInformation();
            setOpenNextOfKin(true);
          }}
        />
      )}

      {openAddBorrowerSuccess && (
        <BorrowerSuccess closeAddBorrowerSuccess={closeAddBorrowerSuccess} />
      )}
      {openBorrowerFilter && (
        <BorrowerFilter
          closeFilters={closeBorrowerFilter}
          handleApplyFilter={handleApplyFilters}
          status={status}
          setStatus={setStatus}
          selectedRole={selectedRole}
          setSelectedRole={setSelectedRole}
          selectedBranch={selectedBranch}
          setSelectedBranch={setSelectedBranch}
          selectedGender={selectedGender}
          setSelectedGender={setSelectedGender}
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
        />
      )}
      {isLoading ? (
        <BorrowersSkeleton />
      ) : (
        <div className="w-full pl-[10px]">
          <div className="flex items-center my-[10px] justify-between">
            <p className="font-bold text-[24px] text-[#222222]">Borrowers</p>
            <button
              onClick={togglePersonalInformation}
              className="bg-[#000000] rounded-[30px] h-[40px] text-white text-[15px] flex items-center justify-center gap-[10px] px-[20px]"
            >
              <Plus color="#ffffff" size={17} />
              Create a new borrower
            </button>
          </div>
          <div className="flex items-center gap-[20px] pb-[10px]">
            <BorrowerCard
              icon={<Sigma />}
              label="Borrowers with loans"
              value={borrowersStatistics?.totalBorrowersWithLoans ?? 0}
              padColor="#4B5D67"
            />
            <BorrowerCard
              icon={<Circle color="#00A676" />}
              label="Borrowers with loan arrears"
              value={borrowersStatistics?.totalBorrowersWithArrears ?? 0}
              padColor="#00A676"
            />
          </div>
          <div className="h-[70px] w-full bg-white flex items-center justify-between px-[10px]">
            <button
              onClick={refetchBorrowers}
              className="h-[40px] w-[117px] flex items-center justify-center gap-[5px] border border-[#00A676] bg-white rounded-[10px] text-[#00A676] font-medium text-[15px]"
            >
              {isRefetching ? <Loading /> : <Loader size={16} />}
              Update
            </button>
            <div className="h-[40px] w-[117px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-white flex items-center justify-center">
              {selectedBorrowers?.length} Selected
            </div>
            <div
              onClick={displayBorrowerFilter}
              className="h-[40px] cursor-pointer w-[127px] text-[#5C5C5C] font-medium text-[15px] rounded-[10px] border border-[#F3F3F3] bg-[#FBF5F5] flex items-center justify-center gap-[5px]"
            >
              <SortAsc color="#4D5874" />
              <span className="text-[#4D5874]">Filter</span>
              <span className="text-[#000000]">0</span>
            </div>
            <div className="flex items-center border border-gray-300 rounded-md px-2 h-[40px] w-[50%] bg-white">
              <Search className="text-gray-500 w-5 h-5 mr-2" />
              <input
                type="text"
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search borrower name..."
                className="w-full outline-none text-sm text-gray-700 placeholder-gray-400 bg-transparent"
              />
              <button
                onClick={refetchBorrowers}
                className="ml-2 p-2 bg-blue-600 rounded-md hover:bg-blue-700"
              >
                <Search className="w-4 h-4 text-white" />
              </button>
            </div>
            <p className="text-[#000000] truncate text-[15px] font-normal">
              {borrowers?.length} Results
            </p>

            {selectedBorrowers?.length === 0 ? (
              <Dropdown menu={{ items }} trigger={["click"]} placement="bottom">
                <Button className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]">
                  {loadingCustomers ? <Loading /> : <LucideUpload size={17} />}
                  <span>Export</span>
                </Button>
              </Dropdown>
            ) : (
              <Dropdown
                menu={{ items: selectedItems }}
                trigger={["click"]}
                placement="bottom"
              >
                <Button className="flex items-center bg-[#F3F3F3] border-[0.7px] border-[#A8A8A8] h-[40px] rounded-[30px] px-[20px] justify-center gap-[5px] text-[16px] text-[#5C5C5C]">
                  {loadingSelectedCustomers ? (
                    <Loading />
                  ) : (
                    <LucideUpload size={17} />
                  )}
                  <span>Export</span>
                </Button>
              </Dropdown>
            )}
          </div>
          <div>
            <div className="h-[44px] px-[10px] w-full bg-[#F3F3F3] mb-[10px] flex items-center">
              <div className="w-[3%]">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={toggleSelectAll}
                />
              </div>
              <div className="w-[8%] text-[#000] text-[13px] font-bold truncate">
                BORROWER ID
              </div>
              <div className="w-[14%] text-[#000] truncate text-[13px] font-bold truncate">
                BORROWER’S NAME
              </div>
              <div className="w-[10%] text-[#000] text-[13px] font-bold truncate">
                PHONE NUMBER
              </div>
              <div className="w-[10%] text-[#000] text-[13px] font-bold truncate">
                ID NUMBER
              </div>
              <div className="w-[15%] text-[#000] text-[13px] font-bold truncate">
                EMAIL
              </div>
              <div className="w-[10%] text-[#000] text-[13px] font-bold truncate">
                LOCATION
              </div>
              <div className="w-[10%] text-[#000] text-[13px] font-bold truncate">
                CREATED DATE
              </div>
              <div className="w-[10%] text-[#000] text-[13px] font-bold truncate">
                UPDATED DATE
              </div>
              <div className="w-[10%] text-[#000] text-[13px] font-bold truncate">
                STATUS
              </div>
            </div>
            {borrowers?.length > 0 ? (
              borrowers?.map((borrower) => (
                <div
                  key={borrower?.id}
                  className="h-[35px] px-[10px] w-full bg-[#FFFFFF] mb-[10px] flex items-center"
                >
                  <div className="w-[3%]">
                    <input
                      type="checkbox"
                      checked={selectedBorrowers.includes(borrower.id)}
                      onChange={() => toggleSelectBorrower(borrower.id)}
                    />
                  </div>
                  <div
                    onClick={() =>
                      navigate(`/dashboard/borrowers/${borrower?.id}`)
                    }
                    className="w-[8%] cursor-pointer text-[#2A8C52] text-[14px]"
                  >
                    {borrower?.public_id ?? "N/A"}
                  </div>
                  <div className="w-[14%] text-[#000] truncate text-[14px]">
                    {borrower?.firstname ||
                    borrower?.middlename ||
                    borrower?.lastname
                      ? [
                          borrower?.firstname,
                          borrower?.middlename,
                          borrower?.lastname,
                        ]
                          .filter(Boolean)
                          .join(" ")
                      : borrower?.username}
                  </div>
                  <div className="w-[10%] text-[#000] text-[14px]">
                    {borrower?.mobileno ?? "N/A"}
                  </div>
                  <div className="w-[10%] truncate text-[#000] text-[14px]">
                    {borrower?.identification ?? "N/A"}
                  </div>
                  <div className="w-[15%] truncate text-[#000] text-[14px]">
                    {borrower?.email ?? "N/A"}
                  </div>
                  <div className="w-[10%] text-[#000] text-[14px]">
                    {borrower?.residences?.[0]?.residencePhysicalAddress ??
                      "N/A"}
                  </div>
                  <div className="w-[10%] text-[#000] text-[14px]">
                    {formatDate(borrower?.createdAt) ?? "N/A"}
                  </div>
                  <div className="w-[10%] text-[#000] text-[14px]">
                    {formatDate(borrower?.updatedAt) ?? "N/A"}
                  </div>
                  <div className="w-[10%] text-[#000] text-[14px]">
                    {borrower?.status ?? "Active"}
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center py-28 px-6 text-center">
                <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center mb-6 relative">
                  <Search size={40} className="text-gray-200" />
                  <div className="absolute -bottom-1 -right-1 w-8 h-8 bg-white shadow-md rounded-full flex items-center justify-center">
                    <Info size={16} className="text-gray-400" />
                  </div>
                </div>

                <h3 className="text-gray-900 font-bold text-xl tracking-tight">
                  No Borrowers Found
                </h3>
                <p className="text-gray-500 max-w-sm mt-2 text-[14px] leading-relaxed">
                  Your borrower directory is empty. Try adjusting your filters
                  or add a new borrower to get started.
                </p>

                <div className="mt-8 flex items-center gap-3">
                  <button
                    onClick={togglePersonalInformation}
                    className="px-6 py-2.5 bg-[#2A8C52] text-white text-sm font-semibold rounded-xl hover:shadow-lg hover:shadow-green-900/20 transition-all flex items-center gap-2"
                  >
                    <UserPlus size={18} />
                    Register Borrower
                  </button>
                </div>
              </div>
            )}
            <div className="h-[50px] mb-[20px] flex items-center justify-between">
              <div className="flex items-center gap-[10px]">
                <p className="text-[15px] text-[#5C5C5C] font-normal">
                  {start}–{end} of {totalItems}
                </p>
                <p className="text-[15px] text-[#5C5C5C] font-normal">
                  Row/Page:
                </p>
                <p className="text-[15px] text-[#5C5C5C] font-normal">
                  {page}/{totalPages}
                </p>
                <select
                  className="h-[35px] w-[100px] px-[10px] text-[12px]"
                  name="row"
                  id="row"
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                >
                  <option value="10">10 items</option>
                  <option value="20">20 items</option>
                  <option value="25">25 items</option>
                </select>
              </div>
              <div>
                <Pagination
                  currentPage={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Borrrowers;
